var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SelectComponent',_vm._g(_vm._b({attrs:{"label":_vm.label,"items":"/api/resource/contact","search":"","multiple":"","empty-label":_vm.$t('select') + '...'},model:{value:(_vm.comp),callback:function ($$v) {_vm.comp=$$v},expression:"comp"}},'SelectComponent',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }